import { extractLink, extractProvider, extractTitle } from '@atlaskit/link-extractors';
import { extractIcon } from '../common/icon';
import { extractLozenge } from '../common/lozenge';
import { extractTitleTextColor } from '../common/primitives';
import { extractTitlePrefix } from '../common/title-prefix';
import { CONFLUENCE_GENERATOR_ID, JIRA_GENERATOR_ID } from '../constants';
export var extractInlineIcon = function extractInlineIcon(jsonLd) {
  var showIconLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var provider = extractProvider(jsonLd);
  if (provider && provider.id) {
    if (provider.id === CONFLUENCE_GENERATOR_ID || provider.id === JIRA_GENERATOR_ID) {
      return extractIcon(jsonLd, 'type', showIconLabel);
    }
  }
  return extractIcon(jsonLd, 'provider', showIconLabel);
};
export var extractInlineProps = function extractInlineProps(jsonLd, renderers, removeTextHighlightingFromTitle) {
  var showLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return {
    link: extractLink(jsonLd),
    title: extractTitle(jsonLd, removeTextHighlightingFromTitle),
    lozenge: extractLozenge(jsonLd),
    icon: extractInlineIcon(jsonLd, showLabel),
    titleTextColor: extractTitleTextColor(jsonLd),
    titlePrefix: extractTitlePrefix(jsonLd, renderers, 'inline')
  };
};